import { MenuCoverPromoLinkType, MenuCoverPromotionImageSize, Weekday } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const menuCoverPromoSchema = {
    displayName: 'menu cover promo',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'keyString',
            required: true,
            tooltip: {
                text: 'This title is purely for being able to easily identify the image in the Admin Portal. It is not meant to be user-facing.',
            },
        },
        promoImageSize: {
            displayName: 'Promotion Size Variation',
            type: 'stringEnum',
            enum: MenuCoverPromotionImageSize,
            ui: 'dropdown',
        },
        isEnabled: {
            type: 'bool',
            required: true,
            defaultValue: true,
            displayName: 'Enabled',
        },
        linkType: {
            displayName: 'Link Type',
            type: 'stringEnum',
            enum: MenuCoverPromoLinkType,
            required: true,
            defaultValue: MenuCoverPromoLinkType.NoLink,
            ui: 'dropdown',
        },
        linkTarget: {
            displayName: 'Link Target',
            type: 'keyString',
            required: true,
            conditions: [
                {
                    field: 'linkType',
                    values: [
                        MenuCoverPromoLinkType.MenuItem,
                        MenuCoverPromoLinkType.MenuPage,
                        MenuCoverPromoLinkType.MenuSection,
                    ],
                },
            ],
            tooltip: {
                text: 'Put the mongoId of the menu item or menu section you want.',
            },
        },
        imageFullWidth: {
            displayName: 'Full Width Image',
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            size: {
                width: 2048,
                height: 1138,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.GcnFullWidth],
                },
            ],
        },
        imageHalfWidth: {
            displayName: 'Half Width Image',
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            size: {
                width: 1024,
                height: 1138,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.GcnHalfWidth],
                },
            ],
        },
        imageFullWidthSm: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            displayName: 'Full Width Small Image',
            maxFileSizeMb: 20,
            keepAspectRatio: 'contain',
            required: true,
            size: {
                width: 1080,
                height: 362,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.VitrineSmFullWidth],
                },
            ],
        },
        imageFullWidthMd: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            displayName: 'Full Width Medium Image',
            maxFileSizeMb: 20,
            keepAspectRatio: 'contain',
            required: true,
            size: {
                width: 1080,
                height: 724,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.VitrineMdFullWidth],
                },
            ],
        },
        imageHalfWidthSm: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            displayName: 'Half Width Small Image',
            maxFileSizeMb: 20,
            keepAspectRatio: 'contain',
            required: true,
            size: {
                width: 540,
                height: 362,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.VitrineSmHalfWidth],
                },
            ],
        },
        imageHalfWidthMd: {
            type: 'array',
            elementType: 'object',
            elementSubtype: 'Image',
            elementUniqueIdFieldName: 'origUrl',
            maxCount: 1,
            displayName: 'Half Width Medium Image',
            maxFileSizeMb: 20,
            keepAspectRatio: 'contain',
            required: true,
            size: {
                width: 540,
                height: 724,
            },
            conditions: [
                {
                    field: 'promoImageSize',
                    values: [MenuCoverPromotionImageSize.VitrineMdHalfWidth],
                },
            ],
        },
        availability: {
            type: 'object',
            fields: {
                dateRanges: {
                    displayName: 'Specific Date Ranges',
                    type: 'array',
                    elementType: 'object',
                    elementSubtype: 'DateRange',
                    ui: 'accordion',
                    uiSubtype: 'DateRange',
                },
                daySchedules: {
                    displayName: 'Specific Times in the Week',
                    type: 'array',
                    elementType: 'object',
                    ui: 'accordion',
                    uiSubtype: 'DaySchedule',
                    fields: {
                        weekday: {
                            type: 'stringEnum',
                            enum: Weekday,
                            required: true,
                            isHidden: true,
                        },
                        schedules: {
                            type: 'array',
                            elementType: 'object',
                            elementSubtype: 'Schedule',
                            required: true,
                            minCount: 1,
                            ui: 'accordion',
                            uiSubtype: 'Schedule',
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=menu_cover_promo_schema.js.map